<mat-card-content>
  <form [formGroup]="formGroup">

    <p>
      {{ "conclusao.taxa_necessario_para_validar" | translate }}<b>{{ valor_taxa | currency:'BRL'}}</b>.
    </p>

    <div class="informacao">

      <p>
        {{ "conclusao.forma_de_pagamento" | translate }}
      </p>
      <mat-radio-group formControlName="formaPagamento" aria-label="Select an option">

        @if(_paramCursoData.getMoroNoBrasil()){

          <mat-radio-button  value="2">{{ "conclusao.boleto" | translate }}</mat-radio-button>
        }

        <mat-radio-button  value="10">{{ "conclusao.cartao_credito" | translate }}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="informacao">

      <p>
        {{ "conclusao.quem_realizar_o_pagamento" | translate }}
      </p>

      <mat-radio-group formControlName="pagador" aria-label="Select an option">
        @for(item of radiobutton_responsavel_pagar_boleto; track radiobutton_responsavel_pagar_boleto){

          <mat-radio-button value="{{ item.value }}">{{ item.key }}</mat-radio-button>
        }
      </mat-radio-group>
    </div>

    <div class="informacao">

      <h3>
        {{ "conclusao.ciente_que" | translate}}
      </h3>
      <ol>
        <li>{{ "conclusao.ciente_que_1" | translate }}</li>
        <li>{{ "conclusao.ciente_que_2" | translate}}</li>
        <li>{{ "conclusao.ciente_que_3" | translate}}</li>
      </ol>

    </div>

    <div class="btn">
      <p>
        <mat-checkbox formControlName="aceite">{{ "conclusao.li_e_concordo_com_os_termos" | translate }}</mat-checkbox>
      </p>

      <button matButton="filled"  (click)="finalizar()" [disabled]="!formGroup.valid || !aceite"   >{{ "curso.finalizar" | translate }}</button>
    </div>

  </form>

</mat-card-content>

@if(loading){

<div class="loader-overlay">
  <mat-spinner></mat-spinner>
</div>
}
